// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"11768957","899":"cc5fab8a"}[chunkId] + ".chunk.css";
};